export default function navigation (document, moduleHTML, appEventEmitter) {
  let firstSectionVisible = true
  const mobileNav = document.querySelector('[data-js-mobile-nav]')
  const mobileNavShade = document.querySelector('[data-js-mobile-nav-shade]')
  const mobileNavToggle = document.querySelector('[data-js-mobile-nav-toggle]')
  const mobileSubnavToggles = document.querySelectorAll('[data-js-subnav-toggle]')
  const mobileNavCta = document.querySelector('[data-js-nav-cta]')
  const mobileNavExists = !!mobileNav && !!mobileNavToggle && !!mobileSubnavToggles

  const isNavOpen = () => {
    return mobileNav.classList.contains(mobileNav.dataset.styleNavOpen)
  }

  const showHideMobileCTA = () => {
    const hide = isNavOpen() || firstSectionVisible
    if (mobileNavCta) {
      mobileNavCta.classList.toggle('opacity-0', hide)
      mobileNavCta.classList.toggle('pointer-events-none', hide)
    }
  }

  if (mobileNavExists) {
    [mobileNavToggle, mobileNavShade].forEach((element) => {
      element.addEventListener('click', (e) => {
        mobileNav.classList.toggle(mobileNav.dataset.styleNavOpen)
        mobileNavShade.classList.toggle('hidden')
        showHideMobileCTA()
      })
    })

    mobileSubnavToggles.forEach((element) => {
      element.addEventListener('click', (event) => {
        ['overflow-hidden', 'h-16', 'pb-0'].forEach((className) => element.classList.toggle(className))
        element.children[0].classList.toggle('font-bold')
        element.querySelector('svg').classList.toggle('rotate-180')
        event.stopPropagation()
      })
    })
  }

  const setupIntersectionObserver = () => {
    const observer = new window.IntersectionObserver(
      elements => {
        firstSectionVisible = elements[0].isIntersecting
        showHideMobileCTA()
      },
      {
        root: null, // Document viewport
        rootMargin: '0px', // Added margin around root
        threshold: 0 // When user scrolls past the hero
      }
    )
    // Use first section on page, which is usually the hero
    observer.observe(document.querySelector('section'))
  }

  if ('IntersectionObserver' in window) {
    setupIntersectionObserver()
  }
}
